import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { adminApi } from "@/lib/api";

export default function RequireAdmin({ children }) {
  const [state, setState] = useState(localStorage.getItem("jt_admin_token") ? "checking" : "no");

  useEffect(() => {
    if (state !== "checking") return undefined;
    let alive = true;
    adminApi
      .get("/auth/me")
      .then(() => alive && setState("ok"))
      .catch(() => alive && setState("no"));
    return () => {
      alive = false;
    };
  }, [state]);

  if (state === "no") return <Navigate to="/admin/login" replace />;
  if (state === "checking") return <div className="min-h-screen flex items-center justify-center text-sm text-neutral-500">Loading…</div>;
  return children;
}
